import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type GetMasterOrderQueryVariables = Types.Exact<{
  masterOrderId: Types.Scalars['String']['input'];
}>;


export type GetMasterOrderQuery = { __typename?: 'Query', masterOrder?: { __typename?: 'MasterOrderStateData', tenantId: string, masterOrderId: string, masterOrderNumber: string, poNumber: string, type: Types.OrderType, status: Types.MasterOrderStatus, salesPerson: string, orderEntryUnit: Types.OrderEntryUnit, customer: { __typename?: 'MasterOrderCustomerData', id: string, name: string, billToAddress: { __typename?: 'AddressData', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, location: { __typename?: 'LocationData', id: string, code: string, storeNumber: string, name: string, description: string, region: string, market: string, adGroup: string, globalLocationNumber: string, locationLookupCode?: string | null, priceGroupId?: string | null, priceGroupName?: string | null, termsId?: string | null, termsName?: string | null, route?: string | null, carrier?: string | null, allowOrderBillingAddressEdit?: boolean | null, allowOrderLocationAddressEdit?: boolean | null, freightChargeType?: Types.FreightChargeType | null, freightChargeValue?: number | null, sendOrderEmails?: boolean | null, sendInvoiceEmails?: boolean | null, poRequired?: boolean | null, address: { __typename?: 'CreateAddress', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, salesPeople: Array<{ __typename?: 'SalesPersonData', emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } }>, settings?: { __typename?: 'CustomerLocationSettingsData', deliveryScheduleId?: string | null, retailerName: string, route?: string | null, shippingNotes?: string | null, storeClass: string, zone: string, ruleIds: Array<string>, notes?: Array<{ __typename?: 'NoteData', id: string, submitDate: Types.TDateISO, submittedBy: string, noteText: string }> | null } | null }, contact: { __typename?: 'MasterOrderContactData', firstName: string, lastName: string, title: string, type: Types.ContactType, emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string }, phoneNumber: { __typename?: 'PhoneNumberData', type: Types.PhoneNumberType, value: string } } }, shipFromLocation: { __typename?: 'ShipFromLocationData', name: string }, masterLineItems: Array<{ __typename?: 'MasterLineItemData', id: string, lineNumber: number, itemId: string, sku: string, itemGroup?: string | null, orderedQuantity?: number | null, scheduledQuantity?: number | null, acknowledgedQuantity?: number | null, shippedQuantity?: number | null, name: string, price: number, upc: string, category?: string | null, eaches: number, eachesPerUnit: number, shippingUomName: string, addedBy: string, currency: string, dateAdded: Types.TDateISO, note?: { __typename?: 'LineItemNoteData', noteText: string, submitDate: Types.TDateISO, submittedBy: string } | null }>, scheduledOrders: Array<{ __typename?: 'ScheduledOrderData', orderId: string, orderNumber: string }>, confirmationEmails: Array<{ __typename?: 'ConfirmationEmailData', sent: Types.TDateISO, toEmail: string }> } | null };

export type GetMasterOrdersQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.MasterOrdersDocumentFilterInput>;
  order?: Types.InputMaybe<Array<Types.MasterOrdersDocumentSortInput> | Types.MasterOrdersDocumentSortInput>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  last?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  before?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetMasterOrdersQuery = { __typename?: 'Query', masterOrders?: { __typename?: 'MasterOrdersConnection', totalCount: number, nodes?: Array<{ __typename?: 'MasterOrdersDocument', id: string, tenantId: string, masterOrderId: string, masterOrderNumber: string, poNumber: string, customerId: string, customerName: string, salesPerson?: string | null, masterOrderStatus: Types.MasterOrderStatus, orderType: Types.OrderType, numberOfLines: number, itemIds: string, orderTotal: { __typename?: 'MoneyData', currency: string, amount: number }, scheduledOrders: Array<{ __typename?: 'ScheduledOrderData', orderId: string, orderNumber: string }>, confirmationEmail?: { __typename?: 'ConfirmationEmailData', sent: Types.TDateISO, toEmail: string } | null, locations: { __typename?: 'OrderLocationDocumentData', id: string, code: string, storeNumber: string, name: string, description: string, region: string, market: string, adGroup: string, globalLocationNumber: string, poRequired?: boolean | null, priceGroupId?: string | null, priceGroupName?: string | null, termsId?: string | null, allowOrderBillingAddressEdit?: boolean | null, allowOrderLocationAddressEdit?: boolean | null, address: { __typename?: 'CreateAddress', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, salesPeople: Array<{ __typename?: 'SalesPersonData', emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } }> }, billingAddress: { __typename?: 'AddressData', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string } }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetMasterOrdersGridListQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.MasterOrdersDocumentFilterInput>;
  order?: Types.InputMaybe<Array<Types.MasterOrdersDocumentSortInput> | Types.MasterOrdersDocumentSortInput>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  last?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  before?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetMasterOrdersGridListQuery = { __typename?: 'Query', masterOrders?: { __typename?: 'MasterOrdersConnection', totalCount: number, nodes?: Array<{ __typename?: 'MasterOrdersDocument', id: string, masterOrderId: string, masterOrderNumber: string, poNumber: string, customerName: string, salesPerson?: string | null, masterOrderStatus: Types.MasterOrderStatus, numberOfLines: number, orderType: Types.OrderType, itemIds: string, scheduledOrders: Array<{ __typename?: 'ScheduledOrderData', orderId: string, orderNumber: string }>, orderTotal: { __typename?: 'MoneyData', currency: string, amount: number }, confirmationEmail?: { __typename?: 'ConfirmationEmailData', sent: Types.TDateISO, toEmail: string } | null, locations: { __typename?: 'OrderLocationDocumentData', id: string, code: string, storeNumber: string, name: string, description: string, region: string, market: string, adGroup: string, globalLocationNumber: string, poRequired?: boolean | null, priceGroupId?: string | null, priceGroupName?: string | null, termsId?: string | null, allowOrderBillingAddressEdit?: boolean | null, allowOrderLocationAddressEdit?: boolean | null, address: { __typename?: 'CreateAddress', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, salesPeople: Array<{ __typename?: 'SalesPersonData', emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } }> }, billingAddress: { __typename?: 'AddressData', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string } }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type MasterOrderSummaryFragment = { __typename?: 'MasterOrdersDocument', id: string, tenantId: string, masterOrderId: string, masterOrderNumber: string, poNumber: string, customerId: string, customerName: string, salesPerson?: string | null, masterOrderStatus: Types.MasterOrderStatus, orderType: Types.OrderType, numberOfLines: number, itemIds: string, orderTotal: { __typename?: 'MoneyData', currency: string, amount: number }, scheduledOrders: Array<{ __typename?: 'ScheduledOrderData', orderId: string, orderNumber: string }>, confirmationEmail?: { __typename?: 'ConfirmationEmailData', sent: Types.TDateISO, toEmail: string } | null, locations: { __typename?: 'OrderLocationDocumentData', id: string, code: string, storeNumber: string, name: string, description: string, region: string, market: string, adGroup: string, globalLocationNumber: string, poRequired?: boolean | null, priceGroupId?: string | null, priceGroupName?: string | null, termsId?: string | null, allowOrderBillingAddressEdit?: boolean | null, allowOrderLocationAddressEdit?: boolean | null, address: { __typename?: 'CreateAddress', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, salesPeople: Array<{ __typename?: 'SalesPersonData', emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } }> }, billingAddress: { __typename?: 'AddressData', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string } };

export type MasterOrderGridListFragment = { __typename?: 'MasterOrdersDocument', id: string, masterOrderId: string, masterOrderNumber: string, poNumber: string, customerName: string, salesPerson?: string | null, masterOrderStatus: Types.MasterOrderStatus, numberOfLines: number, orderType: Types.OrderType, itemIds: string, scheduledOrders: Array<{ __typename?: 'ScheduledOrderData', orderId: string, orderNumber: string }>, orderTotal: { __typename?: 'MoneyData', currency: string, amount: number }, confirmationEmail?: { __typename?: 'ConfirmationEmailData', sent: Types.TDateISO, toEmail: string } | null, locations: { __typename?: 'OrderLocationDocumentData', id: string, code: string, storeNumber: string, name: string, description: string, region: string, market: string, adGroup: string, globalLocationNumber: string, poRequired?: boolean | null, priceGroupId?: string | null, priceGroupName?: string | null, termsId?: string | null, allowOrderBillingAddressEdit?: boolean | null, allowOrderLocationAddressEdit?: boolean | null, address: { __typename?: 'CreateAddress', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, salesPeople: Array<{ __typename?: 'SalesPersonData', emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } }> }, billingAddress: { __typename?: 'AddressData', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string } };

export type MasterOrderDetailsFragment = { __typename?: 'MasterOrderStateData', tenantId: string, masterOrderId: string, masterOrderNumber: string, poNumber: string, type: Types.OrderType, status: Types.MasterOrderStatus, salesPerson: string, orderEntryUnit: Types.OrderEntryUnit, customer: { __typename?: 'MasterOrderCustomerData', id: string, name: string, billToAddress: { __typename?: 'AddressData', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, location: { __typename?: 'LocationData', id: string, code: string, storeNumber: string, name: string, description: string, region: string, market: string, adGroup: string, globalLocationNumber: string, locationLookupCode?: string | null, priceGroupId?: string | null, priceGroupName?: string | null, termsId?: string | null, termsName?: string | null, route?: string | null, carrier?: string | null, allowOrderBillingAddressEdit?: boolean | null, allowOrderLocationAddressEdit?: boolean | null, freightChargeType?: Types.FreightChargeType | null, freightChargeValue?: number | null, sendOrderEmails?: boolean | null, sendInvoiceEmails?: boolean | null, poRequired?: boolean | null, address: { __typename?: 'CreateAddress', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, salesPeople: Array<{ __typename?: 'SalesPersonData', emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } }>, settings?: { __typename?: 'CustomerLocationSettingsData', deliveryScheduleId?: string | null, retailerName: string, route?: string | null, shippingNotes?: string | null, storeClass: string, zone: string, ruleIds: Array<string>, notes?: Array<{ __typename?: 'NoteData', id: string, submitDate: Types.TDateISO, submittedBy: string, noteText: string }> | null } | null }, contact: { __typename?: 'MasterOrderContactData', firstName: string, lastName: string, title: string, type: Types.ContactType, emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string }, phoneNumber: { __typename?: 'PhoneNumberData', type: Types.PhoneNumberType, value: string } } }, shipFromLocation: { __typename?: 'ShipFromLocationData', name: string }, masterLineItems: Array<{ __typename?: 'MasterLineItemData', id: string, lineNumber: number, itemId: string, sku: string, itemGroup?: string | null, orderedQuantity?: number | null, scheduledQuantity?: number | null, acknowledgedQuantity?: number | null, shippedQuantity?: number | null, name: string, price: number, upc: string, category?: string | null, eaches: number, eachesPerUnit: number, shippingUomName: string, addedBy: string, currency: string, dateAdded: Types.TDateISO, note?: { __typename?: 'LineItemNoteData', noteText: string, submitDate: Types.TDateISO, submittedBy: string } | null }>, scheduledOrders: Array<{ __typename?: 'ScheduledOrderData', orderId: string, orderNumber: string }>, confirmationEmails: Array<{ __typename?: 'ConfirmationEmailData', sent: Types.TDateISO, toEmail: string }> };

export type MasterLineItemFragment = { __typename?: 'MasterLineItemData', id: string, lineNumber: number, itemId: string, sku: string, itemGroup?: string | null, orderedQuantity?: number | null, scheduledQuantity?: number | null, acknowledgedQuantity?: number | null, shippedQuantity?: number | null, name: string, price: number, upc: string, category?: string | null, eaches: number, eachesPerUnit: number, shippingUomName: string, addedBy: string, currency: string, dateAdded: Types.TDateISO, note?: { __typename?: 'LineItemNoteData', noteText: string, submitDate: Types.TDateISO, submittedBy: string } | null };

export type MasterCustomerFragment = { __typename?: 'MasterOrderCustomerData', id: string, name: string, billToAddress: { __typename?: 'AddressData', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, location: { __typename?: 'LocationData', id: string, code: string, storeNumber: string, name: string, description: string, region: string, market: string, adGroup: string, globalLocationNumber: string, locationLookupCode?: string | null, priceGroupId?: string | null, priceGroupName?: string | null, termsId?: string | null, termsName?: string | null, route?: string | null, carrier?: string | null, allowOrderBillingAddressEdit?: boolean | null, allowOrderLocationAddressEdit?: boolean | null, freightChargeType?: Types.FreightChargeType | null, freightChargeValue?: number | null, sendOrderEmails?: boolean | null, sendInvoiceEmails?: boolean | null, poRequired?: boolean | null, address: { __typename?: 'CreateAddress', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, salesPeople: Array<{ __typename?: 'SalesPersonData', emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } }>, settings?: { __typename?: 'CustomerLocationSettingsData', deliveryScheduleId?: string | null, retailerName: string, route?: string | null, shippingNotes?: string | null, storeClass: string, zone: string, ruleIds: Array<string>, notes?: Array<{ __typename?: 'NoteData', id: string, submitDate: Types.TDateISO, submittedBy: string, noteText: string }> | null } | null }, contact: { __typename?: 'MasterOrderContactData', firstName: string, lastName: string, title: string, type: Types.ContactType, emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string }, phoneNumber: { __typename?: 'PhoneNumberData', type: Types.PhoneNumberType, value: string } } };

export const MasterOrderSummaryFragmentDoc = new TypedDocumentString(`
    fragment MasterOrderSummary on MasterOrdersDocument {
  id
  tenantId
  masterOrderId
  masterOrderNumber
  poNumber
  customerId
  customerName
  salesPerson
  masterOrderStatus
  orderType
  numberOfLines
  orderTotal {
    currency
    amount
  }
  scheduledOrders {
    orderId
    orderNumber
  }
  confirmationEmail {
    sent
    toEmail
  }
  locations {
    ...OrderLocation
  }
  billingAddress {
    ...AddressData
  }
  itemIds
}
    fragment OrderLocation on OrderLocationDocumentData {
  id
  code
  storeNumber
  name
  description
  region
  market
  adGroup
  globalLocationNumber
  address {
    ...Address
  }
  salesPeople {
    ...SalesPerson
  }
  poRequired
  priceGroupId
  priceGroupName
  termsId
  allowOrderBillingAddressEdit
  allowOrderLocationAddressEdit
}
fragment Address on CreateAddress {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment SalesPerson on SalesPersonData {
  emailAddress {
    type
    value
  }
}
fragment AddressData on AddressData {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}`, {"fragmentName":"MasterOrderSummary"});
export const MasterOrderGridListFragmentDoc = new TypedDocumentString(`
    fragment MasterOrderGridList on MasterOrdersDocument {
  id
  masterOrderId
  masterOrderNumber
  poNumber
  customerName
  salesPerson
  masterOrderStatus
  numberOfLines
  orderType
  scheduledOrders {
    orderId
    orderNumber
  }
  orderTotal {
    currency
    amount
  }
  confirmationEmail {
    sent
    toEmail
  }
  locations {
    ...OrderLocation
  }
  billingAddress {
    ...AddressData
  }
  itemIds
}
    fragment OrderLocation on OrderLocationDocumentData {
  id
  code
  storeNumber
  name
  description
  region
  market
  adGroup
  globalLocationNumber
  address {
    ...Address
  }
  salesPeople {
    ...SalesPerson
  }
  poRequired
  priceGroupId
  priceGroupName
  termsId
  allowOrderBillingAddressEdit
  allowOrderLocationAddressEdit
}
fragment Address on CreateAddress {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment SalesPerson on SalesPersonData {
  emailAddress {
    type
    value
  }
}
fragment AddressData on AddressData {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}`, {"fragmentName":"MasterOrderGridList"});
export const MasterCustomerFragmentDoc = new TypedDocumentString(`
    fragment MasterCustomer on MasterOrderCustomerData {
  id
  name
  billToAddress {
    ...AddressData
  }
  location {
    ...Location
  }
  contact {
    emailAddress {
      type
      value
    }
    firstName
    lastName
    phoneNumber {
      type
      value
    }
    title
    type
  }
}
    fragment Address on CreateAddress {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment SalesPerson on SalesPersonData {
  emailAddress {
    type
    value
  }
}
fragment AddressData on AddressData {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment Location on LocationData {
  id
  code
  storeNumber
  name
  description
  region
  market
  adGroup
  globalLocationNumber
  locationLookupCode
  priceGroupId
  priceGroupName
  termsId
  termsName
  route
  carrier
  allowOrderBillingAddressEdit
  allowOrderLocationAddressEdit
  freightChargeType
  freightChargeValue
  sendOrderEmails
  sendInvoiceEmails
  poRequired
  address {
    ...Address
  }
  salesPeople {
    ...SalesPerson
  }
  settings {
    deliveryScheduleId
    retailerName
    route
    shippingNotes
    storeClass
    zone
    notes {
      id
      submitDate
      submittedBy
      noteText
    }
    ruleIds
  }
}`, {"fragmentName":"MasterCustomer"});
export const MasterLineItemFragmentDoc = new TypedDocumentString(`
    fragment MasterLineItem on MasterLineItemData {
  id
  lineNumber
  itemId
  sku
  itemGroup
  orderedQuantity
  scheduledQuantity
  acknowledgedQuantity
  shippedQuantity
  name
  note {
    noteText
    submitDate
    submittedBy
  }
  price
  upc
  category
  eaches
  eachesPerUnit
  shippingUomName
  addedBy
  currency
  dateAdded
}
    `, {"fragmentName":"MasterLineItem"});
export const MasterOrderDetailsFragmentDoc = new TypedDocumentString(`
    fragment MasterOrderDetails on MasterOrderStateData {
  tenantId
  masterOrderId
  masterOrderNumber
  poNumber
  type
  status
  salesPerson
  customer {
    ...MasterCustomer
  }
  shipFromLocation {
    name
  }
  masterLineItems {
    ...MasterLineItem
  }
  scheduledOrders {
    orderId
    orderNumber
  }
  confirmationEmails {
    sent
    toEmail
  }
  orderEntryUnit
}
    fragment MasterLineItem on MasterLineItemData {
  id
  lineNumber
  itemId
  sku
  itemGroup
  orderedQuantity
  scheduledQuantity
  acknowledgedQuantity
  shippedQuantity
  name
  note {
    noteText
    submitDate
    submittedBy
  }
  price
  upc
  category
  eaches
  eachesPerUnit
  shippingUomName
  addedBy
  currency
  dateAdded
}
fragment MasterCustomer on MasterOrderCustomerData {
  id
  name
  billToAddress {
    ...AddressData
  }
  location {
    ...Location
  }
  contact {
    emailAddress {
      type
      value
    }
    firstName
    lastName
    phoneNumber {
      type
      value
    }
    title
    type
  }
}
fragment Address on CreateAddress {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment SalesPerson on SalesPersonData {
  emailAddress {
    type
    value
  }
}
fragment AddressData on AddressData {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment Location on LocationData {
  id
  code
  storeNumber
  name
  description
  region
  market
  adGroup
  globalLocationNumber
  locationLookupCode
  priceGroupId
  priceGroupName
  termsId
  termsName
  route
  carrier
  allowOrderBillingAddressEdit
  allowOrderLocationAddressEdit
  freightChargeType
  freightChargeValue
  sendOrderEmails
  sendInvoiceEmails
  poRequired
  address {
    ...Address
  }
  salesPeople {
    ...SalesPerson
  }
  settings {
    deliveryScheduleId
    retailerName
    route
    shippingNotes
    storeClass
    zone
    notes {
      id
      submitDate
      submittedBy
      noteText
    }
    ruleIds
  }
}`, {"fragmentName":"MasterOrderDetails"});
export const GetMasterOrderDocument = new TypedDocumentString(`
    query GetMasterOrder($masterOrderId: String!) {
  masterOrder(masterOrderId: $masterOrderId) {
    ...MasterOrderDetails
  }
}
    fragment MasterOrderDetails on MasterOrderStateData {
  tenantId
  masterOrderId
  masterOrderNumber
  poNumber
  type
  status
  salesPerson
  customer {
    ...MasterCustomer
  }
  shipFromLocation {
    name
  }
  masterLineItems {
    ...MasterLineItem
  }
  scheduledOrders {
    orderId
    orderNumber
  }
  confirmationEmails {
    sent
    toEmail
  }
  orderEntryUnit
}
fragment MasterLineItem on MasterLineItemData {
  id
  lineNumber
  itemId
  sku
  itemGroup
  orderedQuantity
  scheduledQuantity
  acknowledgedQuantity
  shippedQuantity
  name
  note {
    noteText
    submitDate
    submittedBy
  }
  price
  upc
  category
  eaches
  eachesPerUnit
  shippingUomName
  addedBy
  currency
  dateAdded
}
fragment MasterCustomer on MasterOrderCustomerData {
  id
  name
  billToAddress {
    ...AddressData
  }
  location {
    ...Location
  }
  contact {
    emailAddress {
      type
      value
    }
    firstName
    lastName
    phoneNumber {
      type
      value
    }
    title
    type
  }
}
fragment Address on CreateAddress {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment SalesPerson on SalesPersonData {
  emailAddress {
    type
    value
  }
}
fragment AddressData on AddressData {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment Location on LocationData {
  id
  code
  storeNumber
  name
  description
  region
  market
  adGroup
  globalLocationNumber
  locationLookupCode
  priceGroupId
  priceGroupName
  termsId
  termsName
  route
  carrier
  allowOrderBillingAddressEdit
  allowOrderLocationAddressEdit
  freightChargeType
  freightChargeValue
  sendOrderEmails
  sendInvoiceEmails
  poRequired
  address {
    ...Address
  }
  salesPeople {
    ...SalesPerson
  }
  settings {
    deliveryScheduleId
    retailerName
    route
    shippingNotes
    storeClass
    zone
    notes {
      id
      submitDate
      submittedBy
      noteText
    }
    ruleIds
  }
}`);
export const GetMasterOrdersDocument = new TypedDocumentString(`
    query GetMasterOrders($where: MasterOrdersDocumentFilterInput, $order: [MasterOrdersDocumentSortInput!], $first: Int, $after: String, $last: Int, $before: String) {
  masterOrders(
    where: $where
    order: $order
    first: $first
    after: $after
    last: $last
    before: $before
  ) {
    nodes {
      ...MasterOrderSummary
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment MasterOrderSummary on MasterOrdersDocument {
  id
  tenantId
  masterOrderId
  masterOrderNumber
  poNumber
  customerId
  customerName
  salesPerson
  masterOrderStatus
  orderType
  numberOfLines
  orderTotal {
    currency
    amount
  }
  scheduledOrders {
    orderId
    orderNumber
  }
  confirmationEmail {
    sent
    toEmail
  }
  locations {
    ...OrderLocation
  }
  billingAddress {
    ...AddressData
  }
  itemIds
}
fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}
fragment OrderLocation on OrderLocationDocumentData {
  id
  code
  storeNumber
  name
  description
  region
  market
  adGroup
  globalLocationNumber
  address {
    ...Address
  }
  salesPeople {
    ...SalesPerson
  }
  poRequired
  priceGroupId
  priceGroupName
  termsId
  allowOrderBillingAddressEdit
  allowOrderLocationAddressEdit
}
fragment Address on CreateAddress {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment SalesPerson on SalesPersonData {
  emailAddress {
    type
    value
  }
}
fragment AddressData on AddressData {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}`);
export const GetMasterOrdersGridListDocument = new TypedDocumentString(`
    query GetMasterOrdersGridList($where: MasterOrdersDocumentFilterInput, $order: [MasterOrdersDocumentSortInput!], $first: Int, $after: String, $last: Int, $before: String) {
  masterOrders(
    where: $where
    order: $order
    first: $first
    after: $after
    last: $last
    before: $before
  ) {
    nodes {
      ...MasterOrderGridList
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment MasterOrderGridList on MasterOrdersDocument {
  id
  masterOrderId
  masterOrderNumber
  poNumber
  customerName
  salesPerson
  masterOrderStatus
  numberOfLines
  orderType
  scheduledOrders {
    orderId
    orderNumber
  }
  orderTotal {
    currency
    amount
  }
  confirmationEmail {
    sent
    toEmail
  }
  locations {
    ...OrderLocation
  }
  billingAddress {
    ...AddressData
  }
  itemIds
}
fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}
fragment OrderLocation on OrderLocationDocumentData {
  id
  code
  storeNumber
  name
  description
  region
  market
  adGroup
  globalLocationNumber
  address {
    ...Address
  }
  salesPeople {
    ...SalesPerson
  }
  poRequired
  priceGroupId
  priceGroupName
  termsId
  allowOrderBillingAddressEdit
  allowOrderLocationAddressEdit
}
fragment Address on CreateAddress {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment SalesPerson on SalesPersonData {
  emailAddress {
    type
    value
  }
}
fragment AddressData on AddressData {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    GetMasterOrder: build.query<GetMasterOrderQuery, GetMasterOrderQueryVariables>({
      query: (variables) => ({ document: GetMasterOrderDocument, variables })
    }),
    GetMasterOrders: build.query<GetMasterOrdersQuery, GetMasterOrdersQueryVariables | void>({
      query: (variables) => ({ document: GetMasterOrdersDocument, variables })
    }),
    GetMasterOrdersGridList: build.query<GetMasterOrdersGridListQuery, GetMasterOrdersGridListQueryVariables | void>({
      query: (variables) => ({ document: GetMasterOrdersGridListDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useGetMasterOrderQuery, useLazyGetMasterOrderQuery, useGetMasterOrdersQuery, useLazyGetMasterOrdersQuery, useGetMasterOrdersGridListQuery, useLazyGetMasterOrdersGridListQuery } = injectedRtkApi;
